import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";
import { isTV } from "../../../utils/platform";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background: "rgba(0, 0, 0, 0.80)",
    width: "100vw",
    height: "100vh",
    zIndex: theme.zIndex.dialog,
    display: "flex",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    maxWidth: "100%",
    maxHeight: "100%",
  },
  mediaList: {
    display: "flex",
    overflowX: "scroll",
    alignItems: "center",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    ...(isTV && {
      transform: "translateZ(0)",
      willChange: "scroll-position",
      contain: "layout paint",
    }),
    gap: theme.spacing.space40,
    padding: theme.spacing.space16,
    [BreakPointMobile]: {
      alignItems: "center",
    },
    [BreakPointDesktop]: {
      padding: "0px 40px",
      "& div:nth-of-type(2)": {
        marginLeft: -110,
      },
      "& div:nth-last-of-type(2)": {
        marginRight: -110,
      },
    },
    "& > div:focus:not($selected), & > div:focus-visible:not($selected)": {
      outline: "none",
    },
  },
  mediaListSingle: {
    justifyContent: "center",
    overflowX: "hidden",
    margin: "0 auto",
    "& > div": {
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& iframe": {
      border: "none !important",
    },
  },
  image: {
    width: "90vw",
    minWidth: "90vw",
    objectFit: "cover",
    minHeight: 430,
    [BreakPointMobile]: {
      height: "unset",
      minHeight: 180,
      "@media (orientation: landscape)": {
        minHeight: "100vh",
      },
    },
    [BreakPointDesktop]: {
      height: "calc(85vh - 48px)",
      minHeight: "calc(85vh - 48px)",
    },
  },
  videoOverlay: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    pointerEvents: "none",
    zIndex: theme.zIndex.dialog,
  },
  overlayVideo: {
    flexShrink: 0,
    width: "92.7vw",
    minWidth: "92.7vw",
    objectFit: "cover",
    minHeight: 430,
    [BreakPointDesktop]: {
      height: "calc(87vh - 44px)",
      minHeight: "calc(87vh - 44px)",
    },
  },
  closeIcon: {
    cursor: "pointer",
    position: "fixed",
    padding: theme.spacing.space8,
    zIndex: theme.zIndex.dialog + 1,
    right: theme.spacing.space16,
    top: theme.spacing.space16,
    outline: "none !important",
    boxShadow: "none !important",
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      lineHeight: "32px !important",
      top: 16,
      right: 16,
    },
  },
  iframe: {
    [BreakPointTablet]: {
      minHeight: "40vh",
      "@media (orientation: landscape)": {
        minHeight: "80vh",
      },
    },
    [BreakPointMobile]: {
      minHeight: "30vh",
      "@media (orientation: landscape)": {
        minHeight: "80vh",
      },
    },
  },
  thumbnailWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      objectFit: "cover",
    },
  },
  playVideoIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    [BreakPointMobile]: {
      transform: "translate(-50%, -50%) scale(0.5)",
    },
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
    transform: "scale(1.03)",
    margin: theme.spacing.space16,
    padding: theme.spacing.space6,
  },
}));
